import { useDeferredValue } from "react";
import cx from "ui/cx";
import styles from "./Sidebar.module.scss";

export interface SidebarProps extends React.HTMLAttributes<HTMLDivElement> {
  open: boolean;
  toggleOpen: (open: boolean) => void;
  align: "left" | "right";
  openOnHover?: boolean;
  lockedOpen?: boolean;
  lockedOpenCx?: string;
}

export default function Sidebar({
  open,
  toggleOpen,
  align = "left",
  openOnHover,
  lockedOpen, // disables position:absolute
  children,
  className,
  lockedOpenCx,
  ...props
}: SidebarProps) {
  const locked = useDeferredValue(lockedOpen);
  open = locked || open;
  const handleMouseLeave = !locked && !lockedOpen ? () => toggleOpen(false) : undefined;

  return (
    <>
      {!locked && !open && (
        <div className={cx(styles.openOnHover, styles[align])} onMouseEnter={() => toggleOpen(true)} />
      )}
      <div
        {...props}
        className={cx(
          styles.wrapper,
          open && styles.open,
          styles[align],
          lockedOpen && styles.startLockedOpen,
          locked && !lockedOpen && styles.endLockedOpen,
          locked && styles.lockedOpen,
          locked && lockedOpenCx,
          className,
        )}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </div>
    </>
  );
}
